@if (settingsInitialized) {
<div>
    <table #notificationSettingsTable aria-label="Notification Settings Table" class="location-settings">
        <thead>
            <tr>
                <th scope="col" class="top-left" [class.no-results]="_locations?.length === 0">
                    <div class="location-search-container">
                        <div class="location-search">
                            <label class="fw-bold form-label">{{localize(langSection.LocationList,
                                langText.SearchLocations)}}</label>
                            <div class="input-group-text">
                                <input class="form-control rounded-0 border-dark" [value]="locationSearchTerm$ | async"
                                    (input)="onLocationSearch($event.target.value)" />
                                <button aria-label="Search Locations" class="btn border-dark rounded-0 bg-green"
                                    type="button" (click)="clearLocationSearch()"><span
                                        [ngClass]="(locationSearchTerm$ | async) ? 'clear icon' : 'search icon'"></span></button>
                            </div>
                        </div>
                        @if (totalLocationCount === _locations?.length && totalLocationCount > 1 && _locations?.length > 0) {
<div
                            class="search-message">{{localize(langSection.NotificationSettings, langText.Displaying)}}
                            {{_locations.length}} {{localize(langSection.Term, langText.Locations)}}</div>
}
                        @if (totalLocationCount !== _locations?.length && totalLocationCount > 1 && _locations?.length > 0) {
<div
                            class="search-message">{{localize(langSection.NotificationSettings, langText.Displaying)}}
                            {{_locations.length}} {{localize(langSection.Term, langText.OfMultiple)}}
                            {{totalLocationCount}} {{localize(langSection.Term, langText.Locations)}}</div>
}
                        @if (totalLocationCount === _locations?.length && totalLocationCount === 1 && _locations?.length > 0) {
<div
                            class="search-message">{{localize(langSection.NotificationSettings, langText.Displaying)}}
                            {{_locations.length}} {{localize(langSection.Term, langText.Location)}}</div>
}
                        @if (totalLocationCount !== _locations?.length && totalLocationCount === 1 && _locations?.length > 0) {
<div
                            class="search-message">{{localize(langSection.NotificationSettings, langText.Displaying)}}
                            {{_locations.length}} {{localize(langSection.Term, langText.OfSingle)}}
                            {{totalLocationCount}} {{localize(langSection.Term, langText.Location)}}</div>
}
                        @if ((_locations?.length ?? 0) === 0) {
<div class="search-message">
                            {{localize(langSection.NotificationSettings, langText.NoResultsMatched)}}</div>
}
                    </div>
                </th>
                @if (_locations?.length > 0) {
<th scope="col" class="setting-header" [class.error]="locationColumnErrors.statusChange">
                    <div>
                        <notification-type-header class="status-header"
                            [name]="localize(langSection.NotificationSettings, langText.StatusChange)"
                            [status]="statusChangeStatus"
                            [active]="!dataOutOfDate"
                            (onChange)="setAllStatusChangeToggles($event)"></notification-type-header>
                        @if (showStatusCheckboxes) {
<span class="ups-icon ups-icon-chevron-left" role="button"
                            (click)="toggleStatusCheckboxes();"></span>
}
                        @if (!showStatusCheckboxes) {
<span class="ups-icon ups-icon-chevron-right" role="button"
                            (click)="toggleStatusCheckboxes();"></span>
}
                    </div>
                </th>
}
                @if (_locations?.length > 0) {
<th scope="col" class="setting-header" [class.error]="locationColumnErrors.comment">
                    <notification-type-header [name]="localize(langSection.NotificationSettings, langText.Comment)"
                        [status]="commentStatus" [active]="!dataOutOfDate" (onChange)="setAllCommentToggles($event)"></notification-type-header>
                </th>
}
                @if (_locations?.length > 0) {
<th scope="col" class="setting-header" [class.error]="locationColumnErrors.requestEdited">
                    <notification-type-header
                        [name]="localize(langSection.NotificationSettings, langText.RequestEdited)"
                        [status]="requestEditedStatus"
                        [active]="!dataOutOfDate"
                        (onChange)="setAllRequestEditedToggles($event)"></notification-type-header>
                </th>
}
                @if (showUserRequestToggle && _locations?.length > 0) {
<th scope="col" class="setting-header" [class.error]="locationColumnErrors.userRequest && allUserRequestEnabled">
                    <notification-type-header [name]="localize(langSection.NotificationSettings, langText.UserRequest)"
                        [status]="userRequestStatus" [active]="allUserRequestEnabled"
                        (onChange)="setAllUserRequestToggles($event)"></notification-type-header>
                </th>
}
            </tr>
        </thead>
        @if (_locations?.length > 0) {
<tbody>
            @for (settings of locationSettings; track settingsTrackBy($index, settings)) {
<tr location-settings class="location-row" 
            [settings]="settings" [showStatusCheckboxes]="showStatusCheckboxes" [dataOutOfDate]="dataOutOfDate" (updateHeaders)="updateAllHeaders()"
            (settingsChanged)="onSettingsChanged($event)"></tr>
}
        </tbody>
}
    </table>
</div>
}